import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import { Location } from '@angular/common';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import * as _ from 'lodash';
import { ModalService } from 'src/app/shared/services/modal.service';
import { RequestModalComponent } from 'src/app/components/requests/request-modal/request-modal.component';
import { HeaderService } from 'src/app/shared/services/header/header.service'
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { BusinessUnitEnum } from 'src/app/shared/enum/business-unit.enum';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss']
})
export class RequestsComponent implements OnInit, OnDestroy {

  constructor(
    private customerService: CustomerService,
    private flashMessageService: FlashMessageService,
    private currentUserService: CurrentUserService,
    private location: Location,
    private _redirectUrl: RedirctUrlService,
    private modal: ModalService,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService
  ) { }

  public openRequest: boolean = false;
  public loading: boolean = false;
  public requests: any = [];
  public requestId: any;
  public customersFilterProperty: string = '';
  public customersFilterDirection: string = 'asc';
  public originalRequests;
  public p: any;
  public raTypes = RequestAccessTypesEnum;
  public requestType: string;
  public entitlements = [];
  public currentUser: string;
  public subscription;
  public notifications: any[] = [];
  public businessUnitEnum = BusinessUnitEnum;

  async ngOnInit() {
    this.currentUserService.getUser().then(user => {
      let entitlementObs = _.get(user, 'role.entitlements', []);
      this.entitlements = entitlementObs.map(entitlemtnt => entitlemtnt.code).reduce((a, b) => (a[b] = true, a), {});

      this._setRequestType();
      this.loading = true;
      this._loadRequests();
      this.currentUser = user.firstname;
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  private _setRequestType() {
    if (this.checkPrivilege('HC_INTERNAL_VIEW_REQUESTS')) {
      if (this.checkPrivilege('HC_CUSTOMER_CREATE_USER')) {
        this.requestType = RequestAccessTypesEnum.CUSTOMER;
      } else if (this.checkPrivilege('HC_SUPPLIER_CREATE_USER')) {
        this.requestType = RequestAccessTypesEnum.SUPPLIER;
      } else if (this.checkPrivilege('HC_CR_CREATE_USER')) {
        this.requestType = RequestAccessTypesEnum.CARRIER;
      }
    }
  }

  private _loadRequests() {
    if (
      this.requestType === RequestAccessTypesEnum.CARRIER ||
      this.requestType === RequestAccessTypesEnum.FACTORING_COMPANY
      ) {
      this.customerService.getCarrierRequests(this.requestType)
        .then((resp) => {
          this.requests = resp;
          this.requests.sort((a, b) => (a.date < b.date) ? 1 : -1);
          this.originalRequests = resp;
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          let message = "";
          if (error.json().status == 500) {
            message = "Internal server error while loading requests"
          } else {
            message = error.json().message;
          }
          this.flashMessageService.updateMessage(message);
        });
    } else {
      this.customerService.getCustomerRequests(this.requestType)
        .then((resp) => {
          this.requests = resp;
          this.originalRequests = resp;
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          let message = "";
          if (error.json().status == 500) {
            message = "Internal server error while loading requests"
          } else {
            message = error.json().message;
          }
          this.flashMessageService.updateMessage(message);
        });
    }
  }

  public openRequestModal(id) {
    this.requestId = id;
    this.subscription = this.modal.closeEvent.subscribe(() => {
      this.closeModal();
    });
    this.modal.open(RequestModalComponent, { requestId: this.requestId, requestType: this.requestType });
  }

  public closeModal() {
    this.openRequest = false;
    this._loadRequests();
  }

  public checkPrivilege(entitlement) {
    if (!this.entitlements || !entitlement) return false;
    return this.entitlements[entitlement];
  }

  sortList(property: string, reverse: boolean = false) {
    this.customersFilterProperty = property;
    const array = this.originalRequests;
    if (property === 'businessUnit') {
      array.sort((a: any, b: any) => {
        const A = a[property] || [];
        const B = b[property] || [];
        if (A.length === B.length) {
          const itemA = A.sort().join('');
          const itemB = B.sort().join('');
          let sorting = itemA === itemB ? 0 : itemA > itemB ? 1 : -1;
          return sorting;
        } else {
          return A.length > B.length ? 1 : -1;
        }
      });
    } else {
      array.sort((a: any, b: any) => {
        const itemA = a[property] ? a[property].toUpperCase() : '';
        const itemB = b[property] ? b[property].toUpperCase() : '';
        let sorting = itemA > itemB ? 1 : -1;
        if (itemA === itemB) { sorting = 0; }
        return sorting;
      });
    }
    if (reverse) {
      this.customersFilterDirection = 'desc';
      return array.reverse();
    } else {
      this.customersFilterDirection = 'asc';
      return array;
    }
  }

  sortAsc(property: string) {
    let isSameProperty: boolean = property === this.customersFilterProperty;
    let isSameDirection: boolean = this.customersFilterDirection === 'asc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.customersFilterDirection = 'asc';
      this.requests = this.sortList(property);
    }
  }

  sortDesc(property: string) {
    let isSameProperty: boolean = property === this.customersFilterProperty;
    let isSameDirection: boolean = this.customersFilterDirection === 'desc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.customersFilterDirection = 'desc';
      this.requests = this.sortList(property, true);
    }
  }

  onRequestTypeChange(requestType = this.raTypes.SUPPLIER) {
    this.requestType = requestType;
    this.loading = true;
    this._loadRequests();
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

  public getBusinessUnit(businessUnit) {
    if (!businessUnit) {
      return '';
    }
    return _.join(businessUnit.map(unit => this.businessUnitEnum[unit]), ', ');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
    this.subscription.unsubscribe();
    }

  }
}

